import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio3To124(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMediaObjectRatio3To124"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 4.5h8A1.5 1.5 0 0 1 14.5 6v12a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 18V6A1.5 1.5 0 0 1 5 4.5M2 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm16.018-.25a.75.75 0 0 1 .75-.75h2.44a.75.75 0 0 1 0 1.5h-2.44a.75.75 0 0 1-.75-.75m0 6a.75.75 0 0 1 .75-.75h2.44a.75.75 0 0 1 0 1.5h-2.44a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h1.397a.75.75 0 0 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h1.397a.75.75 0 0 1 0 1.5h-1.397a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio3To124);
